// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator__1upRD","indicator-green":"Indicator_indicator-green__2ny7O","indicator-wrapper":"Indicator_indicator-wrapper__31bwj"};